module.exports = __WEBPACK_EXTERNAL_MODULE_9__;


//////////////////
// WEBPACK FOOTER
// external "oasi-main-theme/dist/oasi-main-theme.css"
// module id = 9
// module chunks = 0